import { createSlice } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { GenericList } from '@sda/helpers/helpers.types';
import type { SnapshotQueryResult } from '@sda/sdk/interfaces';

interface ListenersState {
  readonly items: GenericList<SnapshotQueryResult>;
}

const initialState: ListenersState = {
  items: {},
};

const listenersSlice = createSlice({
  initialState,
  name: 'listeners',
  reducers: {
    addFirestoreListener: (state, action: PayloadAction<{ name: string, watchListener: SnapshotQueryResult }>) => {
      if (state.items[action.payload.name]) {
        state.items[action.payload.name](); // Unsubscribe if the listener already exists
      }

      state.items[action.payload.name] = action.payload.watchListener;
    },
    removeFirestoreListener: (state, action: PayloadAction<string>) => {
      if (state.items[action.payload]) {
        state.items[action.payload](); // Unsubscribe

        delete state.items[action.payload];
      }
    },
    purgeFirestoreListeners: (state) => {
      if (!isEmpty(state.items)) {
        Object.values(state.items).forEach((unsubscriber) => {
          if (unsubscriber) {
            unsubscriber();
          }
        });
      }

      state.items = {};
    },
  },
});

export const {
  addFirestoreListener, removeFirestoreListener, purgeFirestoreListeners,
} = listenersSlice.actions;

export default listenersSlice.reducer;
